import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("pas_token");
    if (!token) return setLoading(false);
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("pas_token"))
      .finally(() => setLoading(false));
  }, []);

  const applyLogin = (data) => {
    localStorage.setItem("pas_token", data.token);
    setUser({ role: data.role, username: data.username, label: data.label });
    return data;
  };

  const login = async (role, pin) => {
    const { data } = await api.post("/auth/login", { role, pin });
    return applyLogin(data);
  };

  const loginUser = async (username, password) => {
    const { data } = await api.post("/auth/login-user", { username, password });
    return applyLogin(data);
  };

  const logout = () => {
    localStorage.removeItem("pas_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, loginUser, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
